import { AddLayerObject } from 'maplibre-gl';

import {
  AcresMapboxLayerIds,
  AcresMapboxVectorSourceLayerIds,
} from '../../../mapbox-layers';

export const floodLayer = (tileSourceUrl: string): AddLayerObject => ({
  id: AcresMapboxLayerIds.FLOOD,
  layout: {
    visibility: 'visible',
  },
  maxzoom: 22,
  minzoom: 10,
  paint: {
    'fill-opacity': 0.5,
    // These images (eg `fld_0p2_pct`) are added to mapbox instance in flood report panel
    // 'fill-pattern': 'fld__reg_flood',
    'fill-pattern': [
      'match',
      ['get', 'subcategory'],
      '1% annual flood hazard',
      'fld_1_pct',
      'Reduced risk due to levee',
      'fld_red_risk',
      'Future 1% annual flood hazard',
      'fld_future_1_pct',
      '0.2% annual flood hazard',
      'fld_0p2_pct',
      'Undetermined flood hazard',
      'fld_undetermined',
      'Increased risk due to levee',
      'fld_inc_risk',
      'Regulatory Floodway',
      'fld_reg_flood',
      'Special Floodway',
      'fld_spec_flood',
      'default',
    ],
  },
  source: {
    maxzoom: 13,
    minzoom: 10,
    tiles: [`${tileSourceUrl}{z}/{x}/{y}`],
    type: 'vector',
  },
  'source-layer': AcresMapboxVectorSourceLayerIds.FLOOD,
  type: 'fill',
});

export const floodLayerWithLabels = (
  tileSourceUrl: string
): AddLayerObject => ({
  id: AcresMapboxLayerIds.FLOOD_LABELS,
  layout: {
    'symbol-placement': 'point',
    'text-allow-overlap': false,
    'text-field': ['get', 'fld_zone'],
    'text-font': ['Roboto Regular', 'Arial Unicode MS Bold'],
    'text-ignore-placement': false,
    visibility: 'visible',
  },
  maxzoom: 13,
  minzoom: 10,
  paint: {
    'text-color': '#12171C',
    'text-halo-color': 'white',
    'text-halo-width': 2,
  },
  source: {
    maxzoom: 13,
    minzoom: 10,
    tiles: [`${tileSourceUrl}{z}/{x}/{y}`],
    type: 'vector',
  },
  'source-layer': AcresMapboxVectorSourceLayerIds.FLOOD,
  type: 'symbol',
});
